/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * This class provides a dictionary of Explore Errors object, Explore Warnings object etc.
 * By design, for consistency, UI should only consume this Object when rendering messages
 */
import StringResources from 'nls/StringResources';

const { ERROR, WARN } = { ERROR: 'Error', WARN: 'Warning', INFO: 'Info', DEBUG : 'Debug' };

const EXPLORE_MESSAGES = [
	{
		code: 'REL_001', //Please input the entry sorted by error code
		severity: ERROR,
		title: 'relationshipGraph_ambiguous_connection_errorTitle', //Message key defined in ExploreResources
		message: 'relationshipGraph_ambiguous_connection_errorMessage', //Message key defined in ExploreResources
		suggestions: null
	},
	{
		code: 'REL_002',
		severity: ERROR,
		title: 'relationshipGraph_not_joined_errorTitle', //Message key defined in ExploreResources
		message: 'relationshipGraph_not_joined_errorMessage', //Message key defined in ExploreResources
		suggestions: null
	},
	{
		code: 'REL_003', // for abandoned Request Error
		severity: WARN,
		title: 'relationshipGraph_abandoned_errorTitle', //Message key defined in ExploreResources
		message: 'relationshipGraph_abandoned_errorMessage', //Message key defined in ExploreResources
		suggestions: null
	}
	//TODO Expand
];

class ExploreError {
	/**
	 * Get an ExploreError object for the given error code
	 * @param  {string} the unique ExploreError's code
	 * @return {object} the Explore Error object
	 */
	constructor(code){
		const result = EXPLORE_MESSAGES.find(entry=> entry.code === code);
		if(result){
			this.errObj = {
				code: `CA_EXPLORE_${result.code}`,
				severity: result.severity,
				title: StringResources.get(result.title),
				message: StringResources.get(result.message),
				suggestions: result.suggestions ? StringResources.get(result.suggestions) : result.suggestions
			};
		}
	}

	/**
		@return {object} return the Error object
	 */
	getUserStrings(){
		return this.errObj || {}; //Guard it with default Error
	}

}

export default ExploreError;



// WEBPACK FOOTER //
// ./src/js/util/ExploreError.js